import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const fetchLeadersWorkload = (
  setWorkload: Function,
  setIsLoading: Function,
  onlyActive: boolean = true,
  language: string
) => {
  setIsLoading(true);
  ApiService.get(`cohorts/workload/leaders?order=desc&only_active=${onlyActive}`)
    .then((response) =>
      setWorkload(
        response.data.cohorts_leaders_workload.map((element: any, index: number) => ({ ...element, index: index + 1 }))
      )
    )
    .catch((error) => {
      console.error("Error fetching leaders workload:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setIsLoading(false));
};
